import React from 'react';
import Link from 'next/link';
import { Skeleton } from 'antd';

function BlogSidebar({ blog, loading }) {
  return (
    <aside className="widget-area" id="secondary">
      {loading ? (
        <>
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <div className="widget widget_zash_posts_thumb p-3">
          <h3
            className="widget-title font-size-md"
            style={{ fontWeight: '500', color: '#DE2228' }}
          >
            Recent Posts
          </h3>
          {blog?.related?.map((data) => (
            <Link href={`/blog/${data?.slug}`} key={data?.id}>
              <a className="">
                <div className="d-flex flex-column mt-3 mb-3">
                  <img
                    className=""
                    style={{ width: '100%', height: '120px' }}
                    src={
                      data?.photo
                        ? process.env.NEXT_PUBLIC_MEDIA_URL + data?.photo
                        : 'https://d1k0ex3y89plmw.cloudfront.net/media/public/blog_uploads/2022_10_11_06_36_23_ssas.jpg'
                    }
                  />
                  <h4
                    className="text-black font-size-md mt-3 mb-1"
                    style={{ fontWeight: '500' }}
                  >
                    {data.title}
                  </h4>
                  <p
                    className="text-black"
                    style={{ fontSize: '10px', lineHeight: '1.6' }}
                  >
                    {data?.meta_description?.substring(0, 100)}
                    ....{' '}
                  </p>
                </div>
              </a>
            </Link>
          ))}
        </div>
      )}
    </aside>
  );
}

export default BlogSidebar;
